import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Descriptions, Button, Spin, Divider } from 'antd';
import { EditFilled, PrinterOutlined } from '@ant-design/icons';
import { get } from '../redux/actions/ordenTrabajoActions';
import OrdenTrabajoEditor from './OrdenTrabajoEditor';
import OrdenTrabajoPrint from './OrdenTrabajoPrint';
import OrdenTrabajoInsumoList from './OrdenTrabajoInsumoList';
import { callStatus } from '../utils/constants';
import { withRouter } from 'react-router-dom';
import { setBreadcrumbTitle } from '../redux/actions/uiActions';
import dayjs from 'dayjs';

const { Header, Content } = Layout;

const OrdenTrabajoViewer = ({
  dispatch,
  stateData,
  match: {
    params: { id, id2, id3 },
  },
}) => {
  const [showEdit, setShowEdit] = useState(false);
  const [showPrint, setShowPrint] = useState(false);

  const handleHideEditor = () => {
    setShowEdit(false);
  };

  useEffect(() => {
    dispatch(get(id3));
  }, [id3, dispatch]);

  useEffect(() => {
    if (
      stateData.object.status === callStatus.OBJECT_SUCCESS ||
      stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS
    ) {
      dispatch(
        setBreadcrumbTitle(
          `/campanas/${id}/actividades/${id2}/ordenes-trabajo/${id3}`,
          `OT ${stateData.object.data.numero}`
        )
      );
    }
  }, [stateData.object.status, stateData.object.data, dispatch, id, id2, id3]);

  const data = stateData.object.data;
  const loading = stateData.object.status === callStatus.OBJECT_IN_PROCESS;

  return (
    <Layout style={{ height: '100%' }}>
      <Header
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          marginTop: '5px',
          marginBottom: '10px',
          height: 'auto',
          minHeight: '50px',
          backgroundColor: 'transparent',
          padding: 0,
        }}
      >
        <Spin spinning={loading}>
          {(stateData.object.status === callStatus.OBJECT_SUCCESS ||
            stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) &&
            data &&
            data.id && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  height: '100%',
                }}
              >
                <Descriptions
                  bordered
                  size="small"
                  column={4}
                  style={{ marginBottom: 20, flex: 1, marginRight: 20 }}
                >
                  <Descriptions.Item label="Número">
                    {data.numero}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fecha">
                    {data.fecha ? dayjs(data.fecha).format('DD/MM/YYYY') : ''}
                  </Descriptions.Item>
                  <Descriptions.Item label="Labor">
                    {data.labor?.nombre}
                  </Descriptions.Item>
                  <Descriptions.Item label="Estado">
                    {data.estado?.nombre}
                  </Descriptions.Item>
                  <Descriptions.Item label="Contratista">
                    {data.proveedor?.nombre || data.proveedor_nombre}
                  </Descriptions.Item>
                  <Descriptions.Item label="Superficie Ha">
                    {data.superficie}
                  </Descriptions.Item>
                  <Descriptions.Item label="Precio Sup. $">
                    {data.precio_superficie}
                  </Descriptions.Item>
                  <Descriptions.Item label="Dólar">
                    {data.dolar}
                  </Descriptions.Item>
                  <Descriptions.Item label="Importe U$D">
                    {data.importe}
                  </Descriptions.Item>
                  <Descriptions.Item label="Observación" span={3}>
                    {data.observacion}
                  </Descriptions.Item>
                </Descriptions>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                  }}
                >
                  <Button
                    icon={<EditFilled />}
                    onClick={() => setShowEdit(true)}
                    type="primary"
                    size="small"
                  >
                    Editar
                  </Button>
                  <Button
                    icon={<PrinterOutlined />}
                    onClick={() => setShowPrint(true)}
                    type="default"
                    size="small"
                  >
                    Imprimir
                  </Button>
                </div>
              </div>
            )}
        </Spin>
      </Header>
      <Content>
        <div
          style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <Divider
            orientation="left"
            style={{ margin: '0 0 10px 0', flexShrink: 0 }}
          >
            Insumos
          </Divider>
          <div style={{ flex: 1, minHeight: 0 }}>
            <OrdenTrabajoInsumoList />
          </div>
        </div>
      </Content>
      {showEdit && (
        <OrdenTrabajoEditor
          id={id3}
          parentId={id2}
          onCancel={handleHideEditor}
          visible={true}
        />
      )}
      {showPrint && (
        <OrdenTrabajoPrint
          id={id3}
          onCancel={() => setShowPrint(false)}
          visible={true}
        />
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { ordenTrabajo } = state;
  const stateData = ordenTrabajo;
  return {
    stateData,
  };
};

export default connect(mapStateToProps)(withRouter(OrdenTrabajoViewer));
